export function toAlertType(type: string | undefined): 'success' | 'warning' | 'danger' | 'info' {
  return ['success', 'warning', 'danger', 'info'].includes(type as any) ? (type as any) : 'danger';
}
